// Code originally from https://codepen.io/OfigenusMaximus/pen/oNyoORG
import React from "react";

const sparkMappings = [
  {left: "160px", bottom: "212px", animation: "spark 1s 0.4s linear infinite"},
  {left: "180px", bottom: "240px", animation: "spark 1s 1s linear infinite"},
  {left: "208px", bottom: "320px", animation: "spark 1s 0.8s linear infinite"},
  {left: "310px", bottom: "400px", animation: "spark 1s 2s linear infinite"},
  {left: "360px", bottom: "380px", animation: "spark 1s 0.75s linear infinite"},
  {left: "390px", bottom: "320px", animation: "spark 1s 0.65s linear infinite"},
  {left: "400px", bottom: "280px", animation: "spark 1s 1s linear infinite"},
  {left: "430px", bottom: "210px", animation: "spark 1s 1.4s linear infinite"},
]

interface SparkProps {
  index: number;
}

export default function Spark(props: SparkProps) {
  const extraCss = sparkMappings[props.index];
  return (
    <div 
      className={`spark absolute w-6 h-20 bg-slate-50	rounded-2xl	z-50 scale-y-0`} 
      style={{transformOrigin: "bottom center", left: extraCss.left, bottom: extraCss.bottom, animation: extraCss.animation}}>
    </div>
  );
}